import constate from "constate";

import { useImpersonationSessionsHook } from "./hooks/useImpersonationSessions";

export const [ImpersonationSessionsProvider, useImpersonationSessions] = constate(
  useImpersonationSessionsHook
);
